export default __webpack_public_path__ + "static/media/authereum.3a0df1c8.webp";